import React from "react";
import { useSelector } from "react-redux";
import selectors from "selectors";
import NewOrderForm from "./index";
import OrderFormProvider from "./provider";
import useTranslate from "hooks/use-translate-language";
import { Page } from "components/ui";
import browserHistory from "browser-history";

const NewAppOrderFormContainer = () => {
  const token = useSelector(selectors.getAuthenticationToken);
  const patientId = useSelector(selectors.getUserId);
  const translate = useTranslate();

  return (
    <Page.Container style={{ margin: 0 }}>
      <Page.Header
        title={translate("orderSupplies")}
        goBack="/"
        closeText="areYouSureYouWantToCancel"
      />
      <Page.Content>
        <OrderFormProvider
          patientId={patientId}
          token={token}
          origin={"Patient Portal"}
          handleCreateOrderSuccess={() => {
            browserHistory.push("/");
          }}
        >
          <NewOrderForm />
        </OrderFormProvider>
      </Page.Content>
    </Page.Container>
  );
};

export default NewAppOrderFormContainer;
